<template>
<!-- 
xs(Extra Small)・・・主にスマホ対応
sm(Small)・・・主にタブレット
md(Medium) ・・・主にノートパソコンや横表示のタブレット
lg(Large)・・・主にデスクトップ
xl(Extra large)・・・4Kや大きなモニター 


v-if="$vuetify.breakpoint.xs"
-->
    <v-dialog v-if="isView" v-model="isView" persistent scrollable width="800">
        <v-card class="mt-3 pa-1">
            <v-card-title class="pa-0">
                <v-app-bar dense color="primary" dark elevation="0">
                    <v-list-item-title>
                        <v-icon>mdi-eye-circle</v-icon>                                                
                        <span>収穫物の観察</span>
                    </v-list-item-title>
                    <TitleButton
                        v-if="!readOnly"
                        @click="onClickSave"
                        color="primary"
                        icon="mdi-floppy"
                        name="保存" />
                    <!-- <TitleButton
                        color="primary"
                        icon="mdi-pencil"
                        name="編集" /> -->
                    <TitleButton
                        color="primary"
                        icon="mdi-close-circle"
                        name="閉じる"
                        @click="isView = false" />
                </v-app-bar>
            </v-card-title>
            <v-card-text style="height:700px" class="pa-0">
                <v-container>
                    <!-- 編集用 -->
                    <v-form ref="form" >
                        <DatePicker 
                            label="作業日"
                            :canEdit="!readOnly"
                            dense
                            v-model="editItems.date" />
                        <ObservateValueRegister
                            :readOnly=readOnly
                            :target=2
                            :observateItemValues="editItems.observateItemValues"
                            :observateItems="observateItems"
                            />
                        <v-row dense>
                            <v-col>
                                <v-text-field 
                                    v-model="editItems.memo" 
                                    clearable 
                                    label="メモ" 
                                    outlined 
                                    type="text" 
                                    counter="50"
                                    :readonly=readOnly
                                    :rules="[validatorMemoLength]" />
                            </v-col>
                        </v-row>
                    </v-form>
                    <!-- 編集/表示兼用の画像一覧 -->
                    <v-row align="center" justify="start" dense no-gutters>
                        <div v-for="image in editItems.images" :key="image.no">
                            <v-col v-if="image.state != 3" class="pt-0 pr-0 pl-0">
                                <div @click="onClickImage(image)" style="width:200px;" class="mr-3">
                                    <v-img
                                        v-if="image.state == 4"                                        
                                        :src="image.image" 
                                        max-width="200"
                                        max-height="200"
                                        aspect-ratio="1">
                                    </v-img>
                                    <v-img
                                        v-if="image.state == 2"                                        
                                        :src="image.image" 
                                        max-width="200"
                                        max-height="200"
                                        aspect-ratio="1">
                                    </v-img>
                                    <v-img
                                        v-if="image.state == 1"                                        
                                        :src="image.url" 
                                        max-width="200"
                                        max-height="200"
                                        aspect-ratio="1">
                                    </v-img>
                                    <v-btn icon color="primary" @click.stop="onClickDeleteImage(image)"><v-icon large>mdi-delete-circle-outline</v-icon></v-btn>
                                </div>
                            </v-col>
                        </div>
                        <!-- <v-col v-if="!readOnly">
                            <ImageImporter @onImportedImage="onImportedImage"/>
                        </v-col> -->
                    </v-row>
                    <v-row v-if="!readOnly">
                        <v-col>
                            <ImageImporter @onImportedImage="onImportedImage" @onImportedUncategorizedImages="onImportedUncategorizedImages" enabledUncategorizedImageSelect/>
                        </v-col>
                    </v-row>
                    <ImageViewer ref="imageViewer" />
                </v-container>
                <!-- コメント -->
                <div v-if="targetObservate != null">
                    <v-divider class="mb-2" />
                    <div v-for="comment in comments" :key="comment.body.commentNo">
                        <div class="d-flex flex-no-wrap">
                            <v-avatar class="ma-3" v-if="!$vuetify.breakpoint.xs" rounded>
                                <v-img v-if="comment.writer.avaterURL == null" src="@/assets/no_avater_image.png"/>
                                <v-img v-if="comment.writer.avaterURL != null" :src="comment.writer.avaterURL"/>
                            </v-avatar>
                            <div>
                                <v-card-text>
                                    <div class="subtitle-2 font-weight-bold mb-1">{{comment.writer.userName}}</div>
                                    <div class="body-2 mb-1" v-html="comment.body.comment.replace(/\r?\n/g, '<br>')" />
                                    <div class="caption">{{comment.body.writer.dateTime}}</div>
                                </v-card-text>
                            </div>
                        </div>
                    </div>
                    <v-container>
                        <v-textarea
                            v-model="comment"
                            label="コメント"
                            rows="2"
                            outlined
                            clearable
                            auto-grow>
                        </v-textarea>
                        <v-btn color="primary" @click="onClickSendNewComment" :disabled="comment.trim().length == 0">投稿する</v-btn>
                    </v-container>
                </div>
            </v-card-text>
        </v-card>                
        <Confirm ref="confirm" />
    </v-dialog>
</template>
<script>
    import fb from '@/firebase/firebase.js'
    import db from '@/firebase/firestore.js'
    import Confirm from '@/components/tools/ConfirmDialog';
    import DatePicker from '@/components/tools/DatePicker';
    import ImageImporter from '@/components/tools/ImageImporter';
    import ImageViewer from '@/components/tools/ImageViewer';
    import TitleButton from '@/components/tools/TitleBarButton';
    import ObservateValueRegister from '@/components/seedling/items/ObservateValueRegister';
    export default {
        props: {
            readOnly: {type: Boolean, default: false}
        },
        components: {
            ImageImporter,
            ImageViewer,
            TitleButton,
            DatePicker,
            ObservateValueRegister,
            Confirm
        },
        data: function () {
            return {
                isView: false,
                targetSeedling: null,   // 観察対象の苗
                targetHarvest: null,    // 観察対象の収穫物
                targetObservate: null,  // 編集対象観察データ(新規の時は、null)
                editItems: {
                    date: "",
                    observateItemValues: [],
                    memo: "",
                    images: [],
                },
                selectingImage: null,
                observateItems: [],
                comments: [],
                comment: "",
                validatorMemoLength: value => value.length <= 50 || '50文字以内で入力して下さい。',
            }
        },
        computed: {
        },
        methods: {
            onClickSave: function () {
                const self = this

                console.log(this.editItems.observateItemValues)

                if (this.editItems.observateItemValues.findIndex((v)=>v.value == null) >= 0){
                    this.$refs.confirm.show({
                        title: "保存",
                        message: "観察データに値が設定されていない項目があります。<br/>このまま登録しますか？",
                        buttonYes: "登録する",
                        buttonNo: "いいえ",
                        width: 500,
                        listenerYes: function () {
                            if (self.editItems.images.length > 0) {
                                self.imageUploader(self.register)
                            } else {
                                self.register()
                            }
                            return true
                        },
                    })
                } else {
                    this.$refs.confirm.show({
                        title: "保存",
                        message: "観察データを登録しますか？",
                        buttonYes: "登録する",
                        buttonNo: "いいえ",
                        width: 400,
                        listenerYes: function () {
                            if (self.editItems.images.length > 0) {
                                self.imageUploader(self.register)
                            } else {
                                self.register()
                            }
                            return true
                        },
                    })
                }
            },
            onClickImage: function (image) {
                this.$refs.imageViewer.show(image)
            },
            onClickDeleteImage: function (image) {
                const self = this
                this.$refs.confirm.show({
                    title: "削除",
                    message: "この写真を削除して宜しいですか？",
                    width: 400,
                    icon: "mdi-alert",
                    buttonYes: "削除する",
                    buttonNo: "しない",
                    listenerYes: function () {
                        switch (image.state) {
                            case 1:
                                image.state = 3
                                break
                            case 2:
                                const index = self.editItems.images.findIndex((v) => v.no === image.no)
                                self.editItems.images.splice(index, 1)
                                break
                        }
                        return true
                    },
                })
            },
            // =====================================================
            // コメント投稿ボタン押下時
            onClickSendNewComment: function () {
                const self = this
                this.$refs.confirm.show({
                    title: "投稿",
                    message: "この観察データへのコメントを投稿しますか？",
                    width: 400,
                    buttonYes: "投稿する",
                    buttonNo: "しない",
                    listenerYes: function () {
                        self.registComment()
                        return true
                    },
                })
            },
            // =====================================================
            // 画像取り込み時(カメラorローカル)
            onImportedImage: function (image) {
                console.log("onImportedImage")
                var newNo = 1
                if (this.editItems.images.length > 0) {
                    newNo = Math.max(...this.editItems.images.map(m => m.no)) + 1
                }
                this.editItems.images.push({
                    no: newNo,
                    state: 2,
                    image: image,
                    url: "",
                    capturedDate: this.df_currentDateTime()
                })
                console.log(this.editItems)
            },
            // =====================================================
            // 未分類の撮影画像取り込み時
            onImportedUncategorizedImages: function (images) {
                console.log("onImportedUncategorizedImages", images)

                const self = this

                //　参考 >> https://hi0a.com/demo/-js/img-base64-datauri/
                const Base64Converter = function(){
                    // URLからファイルを取得
                    this.loadBinaryResource = function(url) {
                        var req = new XMLHttpRequest();
                        req.open('GET', url, false);
                        req.overrideMimeType('text/plain;charset=x-user-defined');
                        req.send(null);
                        if (req.status != 200) return '';
                        return req.responseText;
                    }
                
                    // バイナリデータを文字列に変換
                    this.convertBinaryFile = function(url) {
                        var filestream = this.loadBinaryResource(url);
                        var bytes = [];
                        for (var i = 0; i < filestream.length; i++){
                            bytes[i] = filestream.charCodeAt(i) & 0xff;
                        }
                        // return String.fromCharCode.apply(String, bytes);
                        var result = ""
                        for (var i=0; i<bytes.length; i++) {
                            result += String.fromCharCode(bytes[i])
                        }
                        return result
                    }
                
                    // バイト文字列をbase64文字列に変換
                    this.convertImgDataURL = function(url){
                        var binary_file = this.convertBinaryFile(url);
                        var base64 = btoa(binary_file);
                        var head = binary_file.substring(0,9);
                        var exe = this.checkExe(head);
                        return 'data:image/' + exe + ';base64,' + base64;
                    }
                
                    // バイナリの拡張子をチェック
                    this.checkExe = function(head){
                        if (head.match(/^\x89PNG/)) {
                            return 'png';
                        } else if (head.match(/^BM/)){
                            return 'bmp';
                        } else if (head.match(/^GIF87a/) || head.match(/^GIF89a/)) {
                            return 'gif';
                        } else if (head.match(/^\xff\xd8/)) {
                            return 'jpeg';
                        } else {
                            return false;
                        }
                    }
                }

                var newNo = 1

                if (this.editItems.images.length > 0) {
                    newNo = Math.max(...this.editItems.images.map(m => m.no)) + 1
                }

                const converter = new Base64Converter()

                console.log(converter)

                images.forEach(function(image){
                    console.log("image", image)

                    // まだ取り込まれていないイメージか否かをチェックし、取り込まれていなければ取り込む
                    if (self.editItems.images.findIndex((v)=>v.state == 4 && v.source.imageID == image.imageID) < 0) {
                        const item = {
                            no: newNo,
                            state: 4,
                            image: converter.convertImgDataURL(image.image.url),
                            url: "",
                            capturedDate: image.image.capturedDateTime,
                            source: image
                        }

                        console.log(item)

                        self.editItems.images.push(item)

                        newNo++
                    }
                })
            },
            // =====================================================
            // コメント登録と通知
            registComment: function () {
                console.log("registComment", this.targetSeedling, this.targetHarvest, this.targetObservate)
                
                const self = this
                const userUID = this.$store.getters["userUID"]
                const docObservateData = db.collection("users").doc(userUID)
                                         .collection("seedlings").doc(this.targetSeedling.seedlingID)
                                         .collection("harvests").doc(""+this.targetHarvest.harvestNo)
                                         .collection("observates").doc(""+this.targetObservate.observateNo)

                var avaterURL = null

                const writerUserData = this.$store.getters["loggedInUserData"]
                const writerUserUID = this.$store.getters["loggedInUserUID"]

                if (writerUserData.avaterImage != null) {
                    avaterURL = writerUserData.avaterImage.url
                }

                const comment = {
                    version: "1.0.0",
                    commentNo: this.comments.length + 1,
                    target: 2,
                    targetKey: {
                        seedlingID: this.targetSeedling.seedlingID,
                        harvestNo: this.targetHarvest.harvestNo,
                        observateNo: this.targetObservate.observateNo,
                    },
                    writer: {
                        userUID: writerUserUID,
                        dateTime: this.df_currentDateTime()
                    },
                    comment: this.comment,
                }
                
                // console.log(comment)
                const batch = db.batch()
                batch.set(docObservateData.collection("comments").doc(""+comment.commentNo), comment)

                if (userUID != writerUserUID) {
                    const notificationParams = {
                        batch:batch,
                        to: {
                            userUID: userUID
                        },
                        sender: null,
                        content: {
                            type: 20,
                            title: "コメント",
                            message: "収穫物の観察記録に新しいコメントがあります。"
                        },
                        data: {
                            target: 2,
                            targetKey: comment.targetKey,
                        }                        
                    }
                    this.$store.commit("sendNotification", notificationParams)
                }
                batch.commit().then(function(){
                    self.comments.push(
                        {
                            body: comment,
                            writer: {
                                userName: writerUserData.userName,
                                avaterURL: avaterURL
                            }
                        }
                    )
                    self.comment = ""
                    self.$store.commit("notification", {message:"コメントを投稿しました。"})
                    console.log(self.comments)
                    console.log("comment send success")
                }).catch(function(error){
                    console.log("comment send error", error)
                    self.$store.commit("notification", {message:"コメントの投稿に失敗しました。", isError:true})
                })
            },
            // =======================================
            // 新しい観察項目の登録
            registNewObservateItem: function (newItem) {
                const self = this
                const userUID = this.$store.getters["userUID"]
                db.collection("users").doc(userUID).collection("managements").doc("observate").collection("observate_items").doc(""+newItem.id).set(newItem).then(function(){
                    self.$store.commit("notification", {message:"新しい観察項目を登録しました。"})
                }).catch (function(error){
                    self.$store.commit("notification", {message:"観察項目の登録に失敗しました。", isError:true})
                })
            },
            // =======================================
            // 画像をアップロードもしくは削除
            // completed:処理終了後に呼び出すメソッド
            imageUploader: function (completed) {
                
                const userUID = this.$store.getters["userUID"]
                const self = this

                var uploadedNum = 0

                this.editItems.images.forEach(function(image){

                    const filename = image.capturedDate.replace(/\-/g, '').replace(/:/g, '').replace(/ /g, '')
                    const uploadUrl = 
                        "images/users/" + userUID 
                        + "/seedlings/" + self.targetSeedling.seedlingID 
                        + "/harvests/" + self.targetHarvest.harvestNo
                        + "/" + filename

                    var storage = fb.storage().ref()
                    var outputRef = storage.child(uploadUrl)

                    switch (image.state) {
                        case 1:
                            uploadedNum++
                            if (uploadedNum == self.editItems.images.length) {
                                completed()
                            }
                            break;
                        case 2:
                        case 4:
                            // ===============================
                            // 画像のアップロード
                            const startIndex = image.image.indexOf(",") + 1
                            outputRef.putString(image.image.substring(startIndex), 'base64').then(function(snapShot){
                                snapShot.ref.getDownloadURL().then (function(url){
                                    console.log("imageUploader", "upload success("+image.no+")", "download url", url)
                                    image.url = url
                                    uploadedNum++
                                    if (uploadedNum == self.editItems.images.length) {
                                        completed()
                                    }
                                }).catch(function(error){
                                    console.log("画像のURL取得失敗", error)
                                })
                            }).catch(function(error){
                                console.log("画像のアップロード失敗", error)
                            })
                            break;
                        case 3:
                            // =======================================
                            // 画像の削除
                            outputRef.delete().then(function (){
                                console.log("RegisterObservation", "delete success("+image.no+")")
                                uploadedNum++
                                if (uploadedNum == self.editItems.images.length) {
                                    completed()
                                }
                            }).catch(function(error){
                                console.log("画像の削除失敗", error)
                            })
                            break;
                    }
                })
            },
            register: function () {
                const userUID = this.$store.getters["userUID"]
                const self = this

                var observate = null

                const history = this.targetHarvest.placeHistories[this.targetHarvest.placeHistories.length - 1]

                if (this.targetObservate == null) {
                    observate = {
                        version: "1.0.0",
                        seedlingID: this.targetSeedling.seedlingID,
                        harvestNo: this.targetHarvest.harvestNo,
                        harvestPlace: {
                            place: history.place,
                            date: history.date
                        },
                        observateNo: this.targetHarvest.results.observatedNum + 1,
                        date: this.editItems.date,
                        values: [],
                        memo: this.editItems.memo,
                        images: [],
                        register: {
                            userUID: userUID,
                            dateTime: this.df_currentDateTime()
                        },
                        updater: {
                            userUID: "",
                            dateTime: ""
                        }
                    }
                } else {
                    observate = this.targetObservate
                    observate.date = this.editItems.date
                    observate.updater = {
                        userUID: userUID,
                        dateTime: this.df_currentDateTime()
                    }
                    observate.values = []
                    observate.images = []
                }
                
                var from = new Date(this.targetHarvest.date)
                var current = new Date(observate.date)
                var days = ( current - from ) / 86400000

                observate.daysFromHarvest = days

                for(var i=0; i<this.editItems.observateItemValues.length; i++) {
                    observate.values.push(this.editItems.observateItemValues[i])
                }

                for(var i=0; i<this.editItems.images.length; i++) {
                    const image = this.editItems.images[i]
                    switch(image.state) {
                        case 1:
                        case 2:
                        case 4:
                            observate.images.push(
                                {
                                    version: "1.0.0",
                                    url: image.url,
                                    capturedDate: image.capturedDate
                                }
                            )
                            break;
                        case 3:
                            break;
                    }
                }

                console.log("観察データ", observate)

                var batch = db.batch()

                // 観察データ
                batch.set(
                    db.collection("users").doc(userUID)
                    .collection("seedlings").doc(observate.seedlingID)
                    .collection("harvests").doc(""+this.targetHarvest.harvestNo)
                    .collection("observates").doc(""+observate.observateNo), observate)

                // 収穫物が持つ観察数更新(新規登録時のみ)
                if (this.targetObservate == null) {
                    this.targetHarvest.results.observatedNum += 1
                    this.targetHarvest.updater = {
                        userUID: userUID,
                        dateTime: this.df_currentDateTime()
                    }
                    batch.update(
                        db.collection("users").doc(userUID)
                        .collection("seedlings").doc(this.targetSeedling.seedlingID)
                        .collection("harvests").doc(""+this.targetHarvest.harvestNo),
                        {
                            "results.observatedNum": this.targetHarvest.results.observatedNum,
                            "updater": this.targetHarvest.updater
                        }
                    )
                }
                
                // コミット
                batch.commit().then(function(){
                    self.$store.commit("notification", {message:"収穫物の観察データを登録しました。"})
                    if (self.targetObservate == null) {
                        self.$emit("onRegisteredHarvestObservate", {
                            seedling: self.targetSeedling,
                            harvest: self.targetHarvest,
                            observate: observate
                        })
                    }
                    // 未分類から画像を取り込んだ時は、その画像を未分類から削除する
                    self.editItems.images.forEach(function(image){
                        if (image.state == 4) {
                            // ストレージから画像を削除
                            var storage = fb.storage().ref()
                            var outputRef = storage.child("images/users/"+userUID+"/uncategorized_images/"+image.source.imageID)
                            outputRef.delete().then(function(){
                                // ストレージから画像を削除後、DBから削除
                                db.collection("users").doc(userUID).collection("uncategorized_images").doc(image.source.imageID).delete().then(function(){
                                    console.log("uncategorized image deleted")
                                }).catch (function(error){
                                    console.log("uncategorized image delete failed!!(DB)", error)
                                })
                            }).catch(function (error) {
                                console.log("uncategorized image delete failed!!(Storage)", error)
                            })
                        }
                    })
                    self.isView = false
                }).catch (function (error) {
                    console.log(error)
                    self.$store.commit("notification", {message:"収穫物の観察データの登録に失敗しました。", isError:true})
                })
            },
            showFromNotification: function (key) {
                const self = this
                const userUID = this.$store.getters["userUID"]

                const docSeedling = db.collection("users").doc(userUID).collection("seedlings").doc(key.seedlingID)
                docSeedling.get().then(function(seedling){
                    const targetSeedling = seedling.data()
                    const docHarvest = docSeedling.collection("harvests").doc(""+key.harvestNo)
                    docHarvest.get().then(function(harvest){
                        const targetHarvest = harvest.data()
                        docHarvest.collection("observates").doc(""+key.observateNo).get().then(function(observate){
                            const targetObservate = observate.data()
                            self.show(targetSeedling, targetHarvest, targetObservate)
                        })
                    })
                })
            },
            show: async function (targetSeedling, targetHarvest, targetObservate) {
                this.targetSeedling = targetSeedling
                this.targetHarvest = targetHarvest
                this.targetObservate = targetObservate

                console.log(targetSeedling, targetHarvest, targetObservate)

                const self = this
                const userUID = this.$store.getters["userUID"]

                // ====================
                // 必須観察項目の設定
                var requiredItemSetter = function () {
                    self.observateItems.forEach(function(item) {
                        if (item.isRequired && (item.target == 0 || item.target == 2)) {
                            if (self.editItems.observateItemValues.findIndex((v)=>v.id == item.id) < 0) {
                                self.editItems.observateItemValues.push(
                                    {
                                        id: item.id,
                                        value: null
                                    }
                                )
                            }
                        }
                    })
                }

                // ====================
                // 初期化
                var initializer = function () {
                    self.editItems.images = []
                    
                    self.editItems.observateItemValues = []

                    if (self.targetObservate == null) {
                        self.editItems.date = self.df_currentDateTime("yyyy-MM-dd")
                        self.editItems.memo = ""
                        requiredItemSetter()
                    } else {
                        self.editItems.date = self.targetObservate.date
                        self.editItems.memo = self.targetObservate.memo
                        for (var i=0; i<self.targetObservate.values.length; i++) {
                            const value = self.targetObservate.values[i]
                            self.editItems.observateItemValues.push({
                                id: value.id,
                                value: value.value
                            })
                        }
                        self.targetObservate.images.forEach(function(image, index){
                            self.editItems.images.push({
                                no: index+1,
                                state: 1,
                                image: "",
                                url: image.url,
                                capturedDate: image.capturedDate
                            })
                            console.log(self.editItems)
                        })
                        requiredItemSetter()
                    }

                    self.isView = true
                }

                // ====================
                // 観察項目取得
                this.observateItems = []
                await db.collection("users").doc(userUID)
                    .collection("managements").doc("observate")
                    .collection("observate_items").orderBy("order", "asc").get().then(function(snapShot){
                    if (snapShot.size == 0) {
                        initializer()
                    } else {
                        snapShot.forEach(function(doc){
                            const item = doc.data()
                            self.observateItems.push(item)
                            if (self.observateItems.length == snapShot.size) {
                                initializer()
                            }
                        })
                    }
                })

                // ====================
                // 登録されている全てのコメントを取得                
                this.comments = []
                if (targetObservate != null) {
                    db.collection("users").doc(userUID)
                    .collection("seedlings").doc(targetSeedling.seedlingID)
                    .collection("harvests").doc(""+targetHarvest.harvestNo)
                    .collection("observates").doc(""+targetObservate.observateNo)
                    .collection("comments").get().then(function(snapShot){
                        snapShot.forEach(function(doc){
                            var comment = {
                                body: doc.data(),
                                writer: {
                                    userName: "",
                                    avaterURL: ""
                                }
                            }
                            self.mi_userData(comment.body.writer.userUID, comment.writer)
                            self.comments.push(comment)
                        })
                    })
                }
            },
        }
    }
</script>
